module.exports = require("./zen-observable.js").Observable;



//////////////////
// WEBPACK FOOTER
// ../app_shared/~/zen-observable/index.js
// module id = 486
// module chunks = 1